import styled from "styled-components";
import InstructorItem from "../instructor/InstructorItem";
import useInstructor from "../../hooks/instructor/useInstructor";

function AboutUs(){
    const {instructorList} = useInstructor();

    const renderInstructorList = () => {
        if(instructorList.length){
            return instructorList.map((item, index) => {
                return <InstructorItem key={item.id} id={item.id} profileImg={item.profile_img} name={item.name} history={item.history.replace(/\\n/g, "\n")} description={item.description}/>
            })
        }
        return null;
    }
    return(
        <Container>
            <PartName >ABOUT US</PartName>
            <InstructorList>
                {renderInstructorList()}
            </InstructorList>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 60px;
`

const PartName = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: #58AC65;
`

const InstructorList = styled.div`
    justify-content: space-between;
    display: grid;
    gap: 40px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    justify-items: left; /* Center items horizontally in the grid */

    @media (max-width: 768px) {
        grid-template-columns: repeat(1, 1fr);
    }
`

export default AboutUs;